import {
  MiBox,
  MiBuildPageHeader,
  MiButton,
  MiIcon,
  MiList,
  MiMenu,
} from "@miplatform/components";
import {
  BUTTON_LABELS,
  BUTTON_VARIANTS,
  PAGINATION,
  PERMISSIONS,
} from "@miplatform/constants";
import { useRouter } from "@miplatform/hooks";
import { IBidResponse } from "@miplatform/types";
import {
  mdiPencilOutline,
  mdiPlus,
  mdiTrashCanOutline,
  mdiViewCompactOutline,
} from "@mdi/js";
import { usePermissions } from "@mibuildweb/hooks";
import { Box, useTheme } from "@mui/material";
import { SectionInfo } from "../components/SectionInfo/SectionInfo";
import { useBidsViewModel } from "./useBidsViewModel";

export function Bids() {
  const { navigate } = useRouter();
  const theme = useTheme();
  const { isLoading, refresh, bids, setBids, fetchBids, deleteBid } =
    useBidsViewModel();
  const { hasPermission } = usePermissions();

  const canDeleteBid = hasPermission(PERMISSIONS.PLAN.DELETE);
  const canUpdateBid = hasPermission(PERMISSIONS.PLAN.UPDATE);

  const sections = [
    {
      fieldset: [
        {
          renderValue: (data: IBidResponse) => <SectionInfo data={data} />,
        },
      ],
    },
  ];

  const renderItemActions = (item: IBidResponse) => {
    const actions = [];

    if (canUpdateBid) {
      actions.push({
        label: BUTTON_LABELS.EDIT,
        icon: mdiPencilOutline,
        action: () => navigate(`create/${item.id}`),
      });
    }

    if (canDeleteBid) {
      actions.push({
        label: BUTTON_LABELS.DELETE,
        icon: mdiTrashCanOutline,
        action: () => deleteBid(item),
        color: theme.palette.red.main,
      });
    }

    return (
      <Box onClick={(e) => e.stopPropagation()}>
        <MiMenu data={actions} />
      </Box>
    );
  };

  return (
    <>
      <MiBuildPageHeader
        title="Bids"
        titleIcon={
          <MiIcon
            path={mdiViewCompactOutline}
            color={theme.palette.primary.main}
          />
        }
        actionComponent={
          <MiButton
            title="Create Bid"
            variant={BUTTON_VARIANTS.CONTAINED}
            startIcon={{ path: mdiPlus }}
            onClick={() => navigate("create")}
          />
        }
      />
      <MiBox>
        <MiList
          viewType="card"
          data={bids}
          setData={setBids}
          dataProvider={fetchBids}
          paginationMode={PAGINATION.SERVER}
          loading={isLoading}
          refresh={refresh}
          cardProps={{
            sections,
            renderItemActions,
            onClick: (item: IBidResponse) => navigate(`create/${item.id}`),
          }}
        />
      </MiBox>
    </>
  );
}
